import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { PromotionsService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Promotions } from '../../models'

const log = new Logger('PromotionsDetailResolver')
@Injectable({ providedIn: 'root' })
export class PromotionsDetailResolver
  implements Resolve<Observable<Promotions>> {
  constructor(
    private promotionsService: PromotionsService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['pid']
    
    return this.promotionsService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/promotions']))
    )
  }
}
